//@flow
import React, { useEffect, useState} from 'react';
import { PropTypes } from 'prop-types';
import injectSheet from 'react-jss';
import hiverModalCss from '../styles/hiverModal';
import closeBtn from '../images/close.svg';
import Button from './button';
import SVGInline from 'react-svg-inline';

/**
* This file is responsible for displaying a reusable modal
* @author Hrushikesh
*/

const HiverModal = (props) => {

    const [ textInput, setTextInput ] = useState('');
    const [ error, setError ] = useState(false);
    const [ success, setSuccess ] = useState(false);
    const [ showError, setShowError ] = useState(false);
    
    const { shown } = props;
    if(!shown) {
        return null;
    }
    const { 
        validationText,
        classes,
        heading,
        icon,
        modalContent,
        footer,
        showCloseBtn,
        buttonText,
        onSubmit,
        handleModalState,
        modalId,
        validationTextStyle,
        footerParentStyle
    } = props;

    const containerClass = classes.modalCont;

    const getFooter = () => {
        return (
            footer &&
            <div className={`${classes.footer} ${footerParentStyle ? footerParentStyle : ''}`}>
                {footer}
            </div>
        )
    }

    const getModalContent = () => {
        return (
            <React.Fragment>
                {modalContent}
                {
                    validationText &&
                    <div>
                        <div>
                        Type <span style={validationTextStyle ? validationTextStyle : {color: "#1B6FE0"}}>{validationText}</span> in the text box below to confirm
                        </div>
                        <div>
                        <input type="text"
                            className = {showError ? 'error' : ''}
                            value = {textInput}
                            onChange = {(e) => { setTextInput(e.target.value) }}
                            placeholder={validationText}
                            id="confirmation-box"
                            autoComplete="off"
                        />
                        </div>
                    </div>
                }
            </React.Fragment>
        )
    }

    const getHeading = () => {
        return (
            <React.Fragment>
                { icon && 
                    <div className={classes.icon}>
                        <SVGInline svg={icon} className={`${classes.icon} h-mr-13p`} id="popup-icon"/>
                    </div>
                }
                {heading}
            </React.Fragment>
        )
    }

    const getCloseButton = () => {
        return (
            <React.Fragment>
                {showCloseBtn && 
                    <div id="close-btn-wrapper" className={classes.closeButtonWrapper} onClick={() => handleModalState(false)}>
                        <SVGInline svg={closeBtn} id="close-btn" />
                    </div>
                }
            </React.Fragment>
        )
    }

    const  onConfirmSubmit = () => {
        if(validationText) {
            const inputBox = document.getElementById("confirmation-box");
            inputBox.style.animation = 'none';
            void inputBox.offsetWidth;
            inputBox.style.animation = null; 
        }
        if(error) {
            setShowError(true);
            return
        }
        onSubmit();
    }

    useEffect(
        () => {
            if(textInput && textInput.trim().toLowerCase() == validationText.toLowerCase()) {
                setSuccess(true);
                setError(false);
            } else if(!error) {
                setError(true);
                setSuccess(false);
            }
            setShowError(false);
        }, [textInput]
    )

    return (
        <div className={classes.modal}>
            <div className={`${containerClass} modal-container`} id={modalId}>
                {getCloseButton()}
                <div className={classes.heading}>
                    {getHeading()}
                </div>
                <div className={classes.modalContent} id="popup-text">
                    {getModalContent()}
                </div>
                {
                    validationText ? 
                    <div className={`${classes.modalAction} ${success ? 'activate' : 'deactivate'}`}>
                        <Button
                            buttonText={buttonText}
                            clickHandler={onConfirmSubmit}
                        />
                    </div> :
                    <div className={`${classes.modalAction}`}>
                        <Button
                            buttonText={buttonText}
                            clickHandler={onConfirmSubmit}
                        />
                    </div>
                }
                {getFooter()}
            </div>
        </div>
    );
}

export default injectSheet(hiverModalCss)(HiverModal);

HiverModal.propTypes = {
    shown: PropTypes.bool,
    modalContent: PropTypes.node,
    showCloseBtn: PropTypes.bool,
    buttonText: PropTypes.string,
    onSubmit: PropTypes.func,
    handleModalState: PropTypes.func,
    modalId: PropTypes.string,
    footer: PropTypes.node || null,
    validationText: PropTypes.string || null,
    classes: PropTypes.object || null,
    heading: PropTypes.node || null,
    validationTextStyle: PropTypes.object || null
}